import axios from "axios";

const BASE_URL = `/m-1/comments`;

/**
 * Serwis do komunikacji z API - endpoint /comments
 */
export const CommentsService = {
  getComments,
  getCommentById,
  getUserComments,
};

//tu po tokenie
function getComments() {
  return axios.get(`${BASE_URL}`);
}

//tu po id komentarza
function getCommentById(id) {
  return axios.get(`${BASE_URL}/${id}`);
}

//tu komentarze uzytkownika
function getUserComments(id) {
  return axios.get(`/m-1/users/${id}/comments`);
}
